// extracted by mini-css-extract-plugin
export default {"location-search__fpo-img":"ujaOWX","location-search__header":"QSSCO8"};